import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { firebase as fb, helpers } from 'redux-firebasev3';

import Page from '../Page';
import Loading from '../../components/Loading';
import WelcomeContent from '../../components/WelcomeContent';
import teamIdFromAuth from '../../enhancers/teamIdFromAuth';
import { teamMetaPath } from '../../utils/firebasePaths';

const { dataToJS } = helpers;

@teamIdFromAuth()
@fb(({ teamId }) => [
  `${teamMetaPath(teamId)}/name`,
])
@connect(
  ({ firebase }, { teamId }) => ({
    teamName: dataToJS(firebase, `${teamMetaPath(teamId)}/name`),
  })
)
export default class Welcome extends Component {
  static propTypes = {
    teamId: PropTypes.string.isRequired,
    teamName: PropTypes.string,
  }

  render() {
    const {
      teamName,
    } = this.props;

    if (!teamName) {
      return <Loading />;
    }

    return (
      <Page pageTitle="Welcome">
        <WelcomeContent teamName={teamName} />
      </Page>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/Welcome/index.jsx
 **/